import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';

// import { AuthGuard } from './_guards/auth.guard';
import { LoginGuard } from './_guards/login.guard';
import { RegistrationGuard } from './_guards/registration.guard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },

  {
    path: 'about',
    loadChildren: () =>
      import('./about/about.module').then((m) => m.AboutModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
    canActivate: [RegistrationGuard],
  },
  {
    path: 'my-account',
    loadChildren: () =>
      import('./my-account/my-account.module').then((m) => m.MyAccountModule),
  }, //canActivate: [AuthGuard] , canActivateChild : [AuthGuard]
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyModule
      ),
  },
  {
    path: 'cookie-policy',
    loadChildren: () =>
      import('./cookie-policy/cookie-policy.module').then(
        (m) => m.CookiePolicyModule
      ),
  },
  {
    path: 'security-statement',
    loadChildren: () =>
      import('./security-statement/security-statement.module').then(
        (m) => m.SecurityStatementModule
      ),
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./contact-us/contact-us.module').then((m) => m.ContactUsModule),
  },
  {
    path: 'report-bug',
    loadChildren: () =>
      import('./report-bug/report-bug.module').then((m) => m.ReportBugModule),
  },
  {
    path: 'request-quote',
    loadChildren: () =>
      import('./request-quote/request-quote.module').then(
        (m) => m.RequestQuoteModule
      ),
  },
  {
    path: 'resume-builder',
    loadChildren: () =>
      import('./resume-builder/resume-builder.module').then(
        (m) => m.ResumeBuilderModule
      ),
  },
  {
    path: 'questionnaire',
    loadChildren: () =>
      import('./questionnaire/questionnaire.module').then(
        (m) => m.QuestionnaireModule
      ),
  },
  {
    path: 'latest-news',
    loadChildren: () =>
      import('./latest-news/latest-news.module').then(
        (m) => m.LatestNewsModule
      ),
  },
  {
    path: 'individual-programs',
    loadChildren: () =>
      import('./individual-programs/individual-programs.module').then(
        (m) => m.IndividualProgramsModule
      ),
  },
  {
    path: 'corporate-programs',
    loadChildren: () =>
      import('./corporate-programs/corporate-programs.module').then(
        (m) => m.CorporateProgramsModule
      ),
  },

  {
    path: 'corporate-hirings',
    loadChildren: () =>
      import('./corporate-hirings/corporate-hirings.module').then(
        (m) => m.CorporateHiringsModule
      ),
  },
  {
    path: 'individual-placements',
    loadChildren: () =>
      import(
        './individual-programs/individual-placements/individual-placements.module'
      ).then((m) => m.IndividualPlacementsModule),
  },

  // {
  //   path: 'jobs',
  //   loadChildren: () => import('./jobs/jobs.module').then((m) => m.JobsModule),
  // },
  {
    path: 'evaluate-me',
    loadChildren: () =>
      import('./evaluate-me/evaluate-me.module').then(
        (m) => m.EvaluateMeModule
      ),
  },

  {
    path: 'comparison-bar',
    loadChildren: () =>
      import('./evaluate-me/comparison-bar/comparison-bar.module').then(
        (m) => m.ComparisonBarModule
      ),
  },
  // { path: 'job-detail/:id', loadChildren: () => import('./jobs/job-detail/job-detail.module').then( (m) => m.JobDetailModule ) },
  // { path: 'job-listing', loadChildren: () => import('./jobs/job-listing/job-listing.module').then( (m) => m.JobListingModule)},
  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
